const BLUEBIRD_FULFILLED = 0x2000000
const BLUEBIRD_REJECTED = 0x1000000
const BLUEBIRD_TO_PROMISE_SETTLED_STATUS_MAP = {
  [BLUEBIRD_FULFILLED]: { status: 'fulfilled' },
  [BLUEBIRD_REJECTED]: { status: 'rejected' },
}

export type MaybeBluebirdAllSettledResult<SettledValue> =
  | PromiseSettledResult<SettledValue>
  | {
      _bitField: typeof BLUEBIRD_FULFILLED | typeof BLUEBIRD_REJECTED
      _settledValueField: SettledValue
    }

/**
 * Checks a settled result object for presence of a known property to assert
 * whether it is a `PromiseSettledResult`.
 */
export const isPromiseSettledResult = <
  SettledValue extends unknown[] = unknown[],
>(
  result: MaybeBluebirdAllSettledResult<SettledValue>,
): result is PromiseSettledResult<SettledValue> =>
  !!(result as PromiseSettledResult<SettledValue>).status

/**
 * Settled result transformer. Helpful for uses of `Promise.allSettled` where
 * the host may override builtin Promise with Bluebird Promise, which does not
 * match the shape of a native `PromiseSettledResult`. Use in a Promise callback
 * to normalise the settled result shape.
 *
 * @example
 * Promise.allSettled([...]).then(transformAllSelected)
 */
export const transformAllSettled = <SettledValue extends unknown[] = unknown[]>(
  results: MaybeBluebirdAllSettledResult<SettledValue>[],
) =>
  results.map((result) =>
    isPromiseSettledResult(result)
      ? result
      : ({
          ...BLUEBIRD_TO_PROMISE_SETTLED_STATUS_MAP[result._bitField],
          value: result._settledValueField,
        } as PromiseSettledResult<SettledValue>),
  )
